import { Chart } from 'chart.js/auto';
import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { getMAJAC010 } from '../../../services/Api';
import Calendar from '../../../shared/components/Calendar';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';

registerLocale('ko', ko);
const MAJAC010 = () => {
    const today = moment().toDate();
    const [date, setDate] = useState(moment().subtract(1, 'day').toDate());
    const [recruitBannerStats, setRecruitBannerStats] = useState([]);
    const [sumRecruitBannerStats, setSumRecruitBannerStats] = useState({
        subHi2New: 0,
        icon2FocusNew: 0,
        recNew: 0,
        icon2HotNew: 0,
        fixTot: 0,
        iconFocusTot: 0,
        comTot: 0,
        subGrandOptNew: 0,
        subGrandNew: 0,
        grandOptTot: 0,
        businessNew: 0,
        subCl2New: 0,
        subIconNew: 0,
        subIcon2New: 0,
        hotTot: 0,
        subRecNew: 0,
        iconHotTot: 0,
        hi2New: 0,
        subPremiumOptNew: 0,
        grandOptNew: 0,
        hotRecruitOptNew: 0,
        subBusinessNew: 0,
        hiNew: 0,
        premiumNew: 0,
        clNew: 0,
        premiumOptNew: 0,
        yr: 0,
        grandTot: 0,
        iconNew: 0,
        subPremiumNew: 0,
        cl2Tot: 0,
        subIconHotNew: 0,
        icon2Tot: 0,
        hiTot: 0,
        icon2HotTot: 0,
        recTot: 0,
        iconFocusNew: 0,
        subComNew: 0,
        hotNew: 0,
        hotRecruitOptTot: 0,
        subIcon2FocusNew: 0,
        icon2FocusTot: 0,
        fixNew: 0,
        subHotRecruitOptNew: 0,
        subIconFocusNew: 0,
        subClNew: 0,
        iconHotNew: 0,
        subHiNew: 0,
        businessTot: 0,
        mon: 0,
        clTot: 0,
        premiumOptTot: 0,
        iconTot: 0,
        hi2Tot: 0,
        subIcon2HotNew: 0,
        grandNew: 0,
        cl2New: 0,
        comNew: 0,
        subFixNew: 0,
        icon2New: 0,
        premiumTot: 0,
        subHotNew: 0,
    });
    const [resumeStats, setResumeStats] = useState([]);
    const [memberMonthlyStats, setMemberMonthlyStats] = useState([]);
    const [recruitDailyStats, setRecruitDailyStats] = useState([]);
    const [recruitSummaryStatsDTO, setRecruitSummaryStatsDTO] = useState({});
    const [memberStats, setMemberStats] = useState({});
    const [paymentHourlyStats, setPaymentHourlyStats] = useState({});
    const chartRef = useRef(null);

    const handleDateChange = (date) => {
        const dateFormat = date ? moment(date).format('YYYY/MM/DD') : moment().subtract(1, 'day').format('YYYY/MM/DD');
        setDate(dateFormat);
    };

    const renderChart = (canvasId) => {
        if (!paymentHourlyStats) return;

        const canvas = document.getElementById('chart');
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        const chartConfig = {
            type: 'bar',
            data: {
                labels: [
                    '00',
                    '01',
                    '02',
                    '03',
                    '04',
                    '05',
                    '06',
                    '07',
                    '08',
                    '09',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                    '16',
                    '17',
                    '18',
                    '19',
                    '20',
                    '21',
                    '22',
                    '23',
                ],
                datasets: [
                    {
                        label: '시간대별 등록현황',
                        data: paymentHourlyStats,
                        backgroundColor: '#2cafff',
                        borderColor: '#2cafff',
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        stacked: true,
                    },
                },
            },
        };

        chartRef.current = new Chart(ctx, chartConfig);

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy();
                chartRef.current = null;
            }
        };
    };
    useEffect(() => {
        paymentHourlyStats && renderChart('chart');
        // eslint-disable-next-line
    }, [paymentHourlyStats]);

    useEffect(() => {
        if (recruitBannerStats && recruitBannerStats.length > 0) {
            setSumRecruitBannerStats(
                recruitBannerStats.reduce(
                    (acc, item) => {
                        Object.keys(acc).forEach((key) => {
                            acc[key] += item[key] || 0;
                        });
                        return acc;
                    },
                    {
                        subHi2New: 0,
                        icon2FocusNew: 0,
                        recNew: 0,
                        icon2HotNew: 0,
                        fixTot: 0,
                        iconFocusTot: 0,
                        comTot: 0,
                        subGrandOptNew: 0,
                        subGrandNew: 0,
                        grandOptTot: 0,
                        businessNew: 0,
                        subCl2New: 0,
                        subIconNew: 0,
                        subIcon2New: 0,
                        hotTot: 0,
                        subRecNew: 0,
                        iconHotTot: 0,
                        hi2New: 0,
                        subPremiumOptNew: 0,
                        grandOptNew: 0,
                        hotRecruitOptNew: 0,
                        subBusinessNew: 0,
                        hiNew: 0,
                        premiumNew: 0,
                        clNew: 0,
                        premiumOptNew: 0,
                        yr: 0,
                        grandTot: 0,
                        iconNew: 0,
                        subPremiumNew: 0,
                        cl2Tot: 0,
                        subIconHotNew: 0,
                        icon2Tot: 0,
                        hiTot: 0,
                        icon2HotTot: 0,
                        recTot: 0,
                        iconFocusNew: 0,
                        subComNew: 0,
                        hotNew: 0,
                        hotRecruitOptTot: 0,
                        subIcon2FocusNew: 0,
                        icon2FocusTot: 0,
                        fixNew: 0,
                        subHotRecruitOptNew: 0,
                        subIconFocusNew: 0,
                        subClNew: 0,
                        iconHotNew: 0,
                        subHiNew: 0,
                        businessTot: 0,
                        mon: 0,
                        clTot: 0,
                        premiumOptTot: 0,
                        iconTot: 0,
                        hi2Tot: 0,
                        subIcon2HotNew: 0,
                        grandNew: 0,
                        cl2New: 0,
                        comNew: 0,
                        subFixNew: 0,
                        icon2New: 0,
                        premiumTot: 0,
                        subHotNew: 0,
                    },
                ),
            );
        }
    }, [recruitBannerStats]);

    useEffect(() => {
        const dateFormat = date ? moment(date).format('YYYYMMDD') : null;
        getMAJAC010(dateFormat)
            .then((data) => {
                setRecruitBannerStats(data.data.recruitBannerStats);
                setResumeStats(data.data.resumeStats);
                setMemberMonthlyStats(data.data.memberMonthlyStats);
                setRecruitDailyStats(
                    data.data.recruitDailyStats.map((item) => ({
                        sdate: item.sdate,
                        value: item.totRecMon,
                    })),
                );
                setRecruitSummaryStatsDTO(data.data.recruitSummaryStatsDTO);
                setMemberStats(data.data.memberStats[0]);
                setPaymentHourlyStats(data.data.paymentHourlyStats.map((item) => item.cnt));
            })
            .catch((error) => console.log(error));
    }, [date]);
    return (
        <div className="statis-page">
            <div className="container-fluid container">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className=" content-right">
                        <div className="title">전체등록</div>
                        <div>
                            <table className="table-gray">
                                <tbody>
                                    <tr>
                                        <th style={{ width: 150 }}>일자</th>
                                        <td colSpan={3} style={{ textAlign: 'left' }}>
                                            <DatePicker
                                                style={{ width: 200 }}
                                                onChange={(date) => handleDateChange(date, 'date')}
                                                locale="ko"
                                                placeholderText="YYYY/MM/DD"
                                                dateFormat="yyyy/MM/dd"
                                                selected={date}
                                                maxDate={today}
                                                showYearDropdown
                                                showMonthDropdown
                                                scrollableYearDropdown
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="table-padding-5">
                            <div className="count-item" style={{ margin: '30px 0 10px' }}>

                            </div>
                            <div className="flex-table">
                                <table className="table-gray">
                                    <thead>
                                        <tr>
                                            <th rowSpan={3}>구분</th>
                                            <th colSpan={2} rowSpan={1}>
                                                구인등록
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                비즈니스배너
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                그랜드배너
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                프리미엄배너
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                핫리쿠르트
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                채용소식
                                                <br />
                                                고정옵션
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                그랜드
                                                <br />
                                                고정옵션
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                프리미엄
                                                <br />
                                                고정옵션
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                핫리쿠르트
                                                <br />
                                                고정옵션
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                하이라이트
                                                <br />
                                                강조 1주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                하이라이트
                                                <br />
                                                강조 2주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                컬러
                                                <br />
                                                강조 1주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                컬러
                                                <br />
                                                강조 2주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                아이콘
                                                <br />
                                                강조 1주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                아이콘
                                                <br />
                                                강조 2주
                                            </th>
                                            <th colSpan={2} rowSpan={1}>
                                                일반
                                                <br />
                                                기업
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                            <th colSpan={2}>{moment(date).format('YYYY')}</th>
                                        </tr>
                                        <tr>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                            <th colSpan={1}>전체</th>
                                            <th colSpan={1}>신/누</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {recruitBannerStats &&
                                            recruitBannerStats.length > 0 &&
                                            recruitBannerStats.map((item, index) => {
                                                return (
                                                    <tr key={`recruitBannerStats-${index}`}>
                                                        <td>{item.mon}월</td>
                                                        <td>{item.recTot}</td>
                                                        <td>{`${item.subRecNew}/${item.recNew}`}</td>
                                                        <td>{item.businessTot}</td>
                                                        <td>{`${item.subBusinessNew}/${item.businessNew}`}</td>
                                                        <td>{item.grandTot}</td>
                                                        <td>{`${item.subGrandNew}/${item.grandNew}`}</td>
                                                        <td>{item.premiumTot}</td>
                                                        <td>{`${item.subPremiumNew}/${item.premiumNew}`}</td>
                                                        <td>{item.hotTot}</td>
                                                        <td>{`${item.subHotNew}/${item.hotNew}`}</td>
                                                        <td>{item.fixTot}</td>
                                                        <td>{`${item.subFixNew}/${item.fixNew}`}</td>
                                                        <td>{item.grandOptTot}</td>
                                                        <td>{`${item.subGrandOptNew}/${item.grandOptNew}`}</td>
                                                        <td>{item.premiumOptTot}</td>
                                                        <td>{`${item.subPremiumOptNew}/${item.premiumOptNew}`}</td>
                                                        <td>{item.hotRecruitOptTot}</td>
                                                        <td>{`${item.subHotRecruitOptNew}/${item.hotRecruitOptNew}`}</td>
                                                        <td>{item.hiTot}</td>
                                                        <td>{`${item.subHiNew}/${item.hiNew}`}</td>
                                                        <td>{item.hi2Tot}</td>
                                                        <td>{`${item.subHi2New}/${item.hi2New}`}</td>
                                                        <td>{item.clTot}</td>
                                                        <td>{`${item.subClNew}/${item.clNew}`}</td>
                                                        <td>{item.cl2Tot}</td>
                                                        <td>{`${item.subCl2New}/${item.cl2New}`}</td>
                                                        <td>{item.iconTot}</td>
                                                        <td>{`${item.subIconNew}/${item.iconNew}`}</td>
                                                        <td>{item.icon2Tot}</td>
                                                        <td>{`${item.subIcon2New}/${item.icon2New}`}</td>
                                                        <td>{item.comTot}</td>
                                                        <td>{`${item.subComNew}/${item.comNew}`}</td>
                                                    </tr>
                                                );
                                            })}

                                        {recruitBannerStats &&
                                            recruitBannerStats.length < 14 &&
                                            Array.from({ length: 14 - recruitBannerStats.length }).map((_, i) => (
                                                <tr key={i}>
                                                    {Array.from({ length: 33 }).map((_, j) => (
                                                        <td key={j}></td>
                                                    ))}
                                                </tr>
                                            ))}
                                        {sumRecruitBannerStats && (
                                            <tr>
                                                <td>Total</td>
                                                <td>{sumRecruitBannerStats.recTot}</td>
                                                <td>{`${sumRecruitBannerStats.subRecNew}/${sumRecruitBannerStats.recNew}`}</td>
                                                <td>{sumRecruitBannerStats.businessTot}</td>
                                                <td>{`${sumRecruitBannerStats.subBusinessNew}/${sumRecruitBannerStats.businessNew}`}</td>
                                                <td>{sumRecruitBannerStats.grandTot}</td>
                                                <td>{`${sumRecruitBannerStats.subGrandNew}/${sumRecruitBannerStats.grandNew}`}</td>
                                                <td>{sumRecruitBannerStats.premiumTot}</td>
                                                <td>{`${sumRecruitBannerStats.subPremiumNew}/${sumRecruitBannerStats.premiumNew}`}</td>
                                                <td>{sumRecruitBannerStats.hotTot}</td>
                                                <td>{`${sumRecruitBannerStats.subHotNew}/${sumRecruitBannerStats.hotNew}`}</td>
                                                <td>{sumRecruitBannerStats.fixTot}</td>
                                                <td>{`${sumRecruitBannerStats.subFixNew}/${sumRecruitBannerStats.fixNew}`}</td>
                                                <td>{sumRecruitBannerStats.grandOptTot}</td>
                                                <td>{`${sumRecruitBannerStats.subGrandOptNew}/${sumRecruitBannerStats.grandOptNew}`}</td>
                                                <td>{sumRecruitBannerStats.premiumOptTot}</td>
                                                <td>{`${sumRecruitBannerStats.subPremiumOptNew}/${sumRecruitBannerStats.premiumOptNew}`}</td>
                                                <td>{sumRecruitBannerStats.hotRecruitOptTot}</td>
                                                <td>{`${sumRecruitBannerStats.subHotRecruitOptNew}/${sumRecruitBannerStats.hotRecruitOptNew}`}</td>
                                                <td>{sumRecruitBannerStats.hiTot}</td>
                                                <td>{`${sumRecruitBannerStats.subHiNew}/${sumRecruitBannerStats.hiNew}`}</td>
                                                <td>{sumRecruitBannerStats.hi2Tot}</td>
                                                <td>{`${sumRecruitBannerStats.subHi2New}/${sumRecruitBannerStats.hi2New}`}</td>
                                                <td>{sumRecruitBannerStats.clTot}</td>
                                                <td>{`${sumRecruitBannerStats.subClNew}/${sumRecruitBannerStats.clNew}`}</td>
                                                <td>{sumRecruitBannerStats.cl2Tot}</td>
                                                <td>{`${sumRecruitBannerStats.subCl2New}/${sumRecruitBannerStats.cl2New}`}</td>
                                                <td>{sumRecruitBannerStats.iconTot}</td>
                                                <td>{`${sumRecruitBannerStats.subIconNew}/${sumRecruitBannerStats.iconNew}`}</td>
                                                <td>{sumRecruitBannerStats.icon2Tot}</td>
                                                <td>{`${sumRecruitBannerStats.subIcon2New}/${sumRecruitBannerStats.icon2New}`}</td>
                                                <td />
                                                <td>/</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <table className="table-gray border-lr-none" style={{ width: '3%' }}>
                                    <thead>
                                        <tr>
                                            <th>
                                                구직
                                                <br />
                                                등록
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>{moment(date).format('YYYY')}</th>
                                        </tr>
                                        <tr>
                                            <th>신규</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resumeStats &&
                                            resumeStats.length > 0 &&
                                            resumeStats.map((item, index) => {
                                                return (
                                                    <tr key={`resumeStats-${index}`}>
                                                        <td>{item.resNew}</td>
                                                    </tr>
                                                );
                                            })}
                                        {recruitBannerStats &&
                                            recruitBannerStats.length < 14 &&
                                            Array.from({ length: 14 - recruitBannerStats.length }).map((_, i) => (
                                                <tr key={i}>
                                                    <td></td>
                                                </tr>
                                            ))}
                                        <tr className="total">
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className="table-gray" style={{ width: '3%' }}>
                                    <thead>
                                        <tr>
                                            <th>
                                                치과
                                                <br />
                                                등록
                                            </th>
                                            <th>
                                                개인
                                                <br />
                                                등록
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>{moment(date).format('YYYY')}</th>
                                            <th>{moment(date).format('YYYY')}</th>
                                        </tr>
                                        <tr>
                                            <th>신규</th>
                                            <th>신규</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {memberMonthlyStats &&
                                            memberMonthlyStats.length > 0 &&
                                            memberMonthlyStats.map((item, index) => {
                                                return (
                                                    <tr key={`memberMonthlyStats-${index}`}>
                                                        <td>{item.cmemNew}</td>
                                                        <td>{item.pmemNew}</td>
                                                    </tr>
                                                );
                                            })}
                                        {memberMonthlyStats &&
                                            memberMonthlyStats.length < 14 &&
                                            Array.from({ length: 14 - memberMonthlyStats.length }).map((_, i) => (
                                                <tr key={i}>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            ))}
                                        <tr className="total">
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="flex-table">
                                <Calendar data={recruitDailyStats} date={moment(date).format('YYYY-MM-DD')} />
                                <div className="right-table">
                                    <table className="table table-gray">
                                        <tbody>
                                            <tr>
                                                <th>일평균 구인등록</th>
                                                <td>{recruitSummaryStatsDTO?.totAvg}</td>
                                            </tr>
                                            <tr>
                                                <th>전체구인등록</th>
                                                <td>{recruitSummaryStatsDTO?.totCnt}</td>
                                            </tr>
                                            <tr>
                                                <th>영업일수</th>
                                                <td>{recruitSummaryStatsDTO?.totDay}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="table table-gray">
                                        <tbody style={{ marginTop: 20 }}>
                                            <tr>
                                                <th>전체 등록회원</th>
                                                <td>
                                                    {isNaN(memberStats?.cmemTot + memberStats?.pmemTot)
                                                        ? '0'
                                                        : memberStats?.cmemTot + memberStats?.pmemTot}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>치과(전체)</th>
                                                <td>{memberStats?.cmemTot || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>개인(전체)</th>
                                                <td>{memberStats?.pmemTot || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>치과(순수신규)</th>
                                                <td>{memberStats?.cmemNew || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>치과(활성신규)</th>
                                                <td>{memberStats?.cmemTrn || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>치과(전환신규)</th>
                                                <td>{memberStats?.cmemGrp || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>개인(순수신규)</th>
                                                <td>{memberStats?.pmemNew || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>개인(활성신규)</th>
                                                <td>{memberStats?.pmemTrn || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>개인(전환신규)</th>
                                                <td>{memberStats?.pmemGrp || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>치과(탈퇴)</th>
                                                <td>{memberStats?.cmemLev || '0'}</td>
                                            </tr>
                                            <tr>
                                                <th>개인(탈퇴)</th>
                                                <td>{memberStats?.pmemLev || '0'}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>※ 2017.9.4 부터 휴면계정전환이 적용된 회원수입니다.</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>※ 순수신규 : 덴탈잡에서 가입</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>※ 활성신규 : 휴면계정에서 활성전환</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>※ 전환신규 : 비타민회원이 그룹구분 설정</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {paymentHourlyStats.length > 0 && (
                                <div className="chart-container" style={{ marginTop: '30px' }}>
                                    <canvas id="chart" width="100%" height="600"></canvas>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAJAC010;
